module.exports = __webpack_public_path__ + "static/media/slideshow-37.650c84a0.jpeg";